import { MaskedTextInput, type MaskedTextInputProps } from '../../controls/masked-text-input';
import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues, Control } from 'react-hook-form';

export interface MaskedTextInputFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<FieldWrapperProps, 'children'>,
    Pick<MaskedTextInputProps, 'mask' | 'placeholder' | 'disabled' | 'isSmallSize'> {
  isReadOnly?: MaskedTextInputProps['readOnly'];
  control?: Control<T>;
}

export const MaskedTextInputField = <T extends FieldValues>({
  label,
  required,
  showError,
  mask,
  placeholder,
  disabled,
  isReadOnly,
  isSmallSize,
  ...props
}: MaskedTextInputFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  return (
    <FieldWrapper label={label} error={error} required={required} showError={showError}>
      <MaskedTextInput
        mask={mask}
        error={error}
        value={field.value ?? ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        name={field.name}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={isReadOnly}
        isSmallSize={isSmallSize}
      />
    </FieldWrapper>
  );
};
